<template>
  <div>
    <wc-section-title title='Clients'>
      <template v-slot:rightSide>
        <client-search></client-search>
      </template>
    </wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
import ClientSearch from './ClientSearch'

export default {
  name: 'clients-base',
  computed: {
    menu () {
      return [
        {
          title: 'Clients Dashboard',
          icon: this.$store.state.icons.modules.clients.icon,
          route: { name: 'ClientsDashboard' }
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Clients Menu')
    this.$store.dispatch('loadMainMenu', this.menu)
  },
  components: {
    'client-search': ClientSearch
  }
}
</script>
